module.exports = __webpack_public_path__ + "img/1F514.44117766.svg";